import Translation from "src/translations/locales/translation";

import { Component, ReactNode } from "react";
import { withTranslation } from "react-i18next";
import { WithTFunction } from "src/types/WithTFunction";

import {
  ResetPasswordScreenResetPasswordRequestedProps,
  ResetPasswordScreenResetPasswordRequestedState,
} from "./index.interfaces";

class ResetPasswordScreenResetPasswordRequested extends Component<
  WithTFunction<ResetPasswordScreenResetPasswordRequestedProps>,
  ResetPasswordScreenResetPasswordRequestedState
> {
  render(): ReactNode {
    const { t } = this.props;

    return (
      <section className="flex flex-col gap-8 desktop:gap-20 w-full max-w-[300px] py-16 tablet:py-28 desktop:py-0 desktop:min-w-[50vw] desktop:px-[12.5%]">
        {/* title and description */}
        <div className="flex flex-col gap-3">
          {/* title */}
          <h1 className="text-lg font-new-atten-bold">
            {t(
              Translation.screens.resetPassword.resetPasswordEmailRequested
                .title,
            ).toUpperCase()}
          </h1>
          {/* description */}
          <p className="opacity-50 text-normal">
            {t(
              Translation.screens.resetPassword.resetPasswordEmailRequested
                .subTitle,
            )}
          </p>
        </div>
      </section>
    );
  }
}

export default withTranslation()(ResetPasswordScreenResetPasswordRequested);
